module.exports = __webpack_public_path__ + "img/Conch_Shell.2cf4f84f.png";